import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

@Injectable()
export class AnalyticsService {
  private gaId: string = environment.g_analytics_id;
  isAnalyticsEnabled: boolean = environment.isAnalyticsEnabled;
  constructor() {
    this.checkAnayticsStatus();
  }

  private checkAnayticsStatus() {
    if (this.isAnalyticsEnabled) {
      this.loadAnalyticsScript();
    }
  }

  private loadAnalyticsScript() {
    const script = document.createElement("script");
    script.src = `https://www.googletagmanager.com/gtag/js?id=${this.gaId}`;
    script.async = true;
    document.head.appendChild(script);
    const gtagScript = document.createElement("script");
    gtagScript.innerHTML = 
       `window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', '${this.gaId}');`;
    document.head.appendChild(gtagScript);
  }


  trackLogin(userId: string, method: string) {
    if (this.isAnalyticsEnabled) {
      (window as any).gtag("config", this.gaId, { user_id: userId });
      (window as any).gtag("event", "login", { method });
    }
  }

  trackPageView(pagePath: string) {
    if (this.isAnalyticsEnabled) {
      (window as any).gtag("config", this.gaId, { page_path: pagePath });
    }
  }

  trackEvent(eventName: string, eventParams: Record<string, any> = {}) {
    // console.log(`Tracking eventName: ${eventName}, eventParams sent: ${JSON.stringify(eventParams)}, anaytics id: ${this.gaId}`);
    if (!this.isAnalyticsEnabled) {
      // console.log("Analytics disabled: trackEvent not tracked");
      return; 
    }
  
    try {
      if (typeof (window as any).gtag === 'function') {
        (window as any).gtag("event", eventName, this.sanitizeEventParams(eventParams));
      } 
    } catch (error) {
      console.error("Error sending event:", error);
    }
  }
  private sanitizeEventParams(eventParams: Record<string, any>): Record<string, any> {
    const sanitizedParams: Record<string, any> = {};
    for (const key in eventParams) {
      if (Object.prototype.hasOwnProperty.call(eventParams, key)) {
        let value = eventParams[key];
        if (typeof value === 'object' || typeof value === 'function') {
          value = JSON.stringify(value); 
        }
        sanitizedParams[key] = value;
      }
    }
    return sanitizedParams;
  }

  trackWorksheetCreate(worksheetName: string) {
    this.trackEvent('worksheet_create', { worksheet_name: worksheetName, submission_time: new Date().toISOString() });
  }

  trackQuoteSubmission(quoteNumber: string) {
    this.trackEvent('quote_submission', { quote_number: quoteNumber.toString(), submission_time: new Date().toISOString() }); 
  }

  trackOrderSubmission(orderNumber: string) {
    this.trackEvent('order_submission', { order_number: orderNumber.toString(), submission_time: new Date().toISOString() });
  }

  trackGlobalSearch(searchKeyword: string, filterType?: string) {
    const eventParams: Record<string, any> = {
      search_keyword: searchKeyword,
      submission_time: new Date().toISOString(),
    };

    if (filterType) {
      eventParams.filter_type = filterType;
    }
    this.trackEvent('global_search', eventParams);
  }

  trackProductSearchWorksheet(searchKeyword: string) {
    this.trackEvent('product_search_worksheet', { search_keyword: searchKeyword, submission_time: new Date().toISOString() });
  }

  trackProductSearchMasterBOM(searchKeyword: string) {
    this.trackEvent('product_search_master_bom', { search_keyword: searchKeyword, submission_time: new Date().toISOString() });
  }

  trackProductSearchWorksheetBOM(searchKeyword: string) {
    this.trackEvent('product_search_ws_bom', { search_keyword: searchKeyword, submission_time: new Date().toISOString() });
  }

  trackMasterBomSearch(searchKeyword: string) {
    this.trackEvent('master_bom_search', { search_keyword: searchKeyword, submission_time: new Date().toISOString() });
  }

  trackTaskSearch(taskType: string) {
    this.trackEvent('task_search', { task_type: taskType, submission_time: new Date().toISOString() });
  }

  trackReportSearch(reportName: string) {
    this.trackEvent('report_view', { report_name: reportName, submission_time: new Date().toISOString() });
  }

  trackSKUOrderConfirmation(sku_issueReported: string) {
    this.trackEvent('order_conf_skus', {sku: sku_issueReported, submission_time: new Date().toISOString() });
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/services/analytics.service.ts